import React from 'react';
import { Form, InputNumber, TimePicker, DatePicker, Row, Col } from 'antd';
import dayjs from 'dayjs';
import zhCN from 'antd/lib/locale/zh_CN';

const TimeSelector = ({ 
  isScheduled = false,
  form
}) => {
  if (isScheduled) {
    // 定时SOP - 使用单个DatePicker组件，启用showTime属性
    return (
      <Row gutter={8}>
        <Col span={12}>
          <Form.Item
            name="scheduledDateTime"
            label="执行时间"
            rules={[{ required: true, message: '请选择执行时间' }]}
            style={{ marginBottom: '10px' }}
          >
            <DatePicker
              showTime={{ format: 'HH:mm:ss' }}
              format="YYYY-MM-DD HH:mm:ss"
              placeholder="请选择执行日期和时间"
              style={{ width: '100%' }}
              locale={zhCN.DatePicker}
              showToday
              allowClear={false}
              inputReadOnly={true}
              getPopupContainer={triggerNode => triggerNode.parentNode}
              popupStyle={{ zIndex: 1050 }}
              disabledDate={current => {
                // 禁用今天之前的日期
                return current && current < dayjs().startOf('day');
              }}
              onChange={(dateTime) => {
                // 选择日期时间后立即应用值
                if (dateTime) {
                  form.setFieldsValue({ scheduledDateTime: dateTime });
                }
              }}
            />
          </Form.Item>
        </Col>
      </Row>
    );
  } else {
    // 常规SOP - 显示相对执行日和具体时间
    return (
      <Row gutter={8}>
        <Col span={6}>
          <Form.Item
            name="timeOffsetDays"
            label="执行天数"
            rules={[{ required: true, message: '请输入执行天数' }]}
            tooltip="触发后多少天执行，0表示立即执行"
            style={{ marginBottom: '10px' }}
          >
            <InputNumber min={0} max={365} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name="executeTime"
            label="执行时间"
            tooltip="具体执行时间，不填则全天有效"
            rules={[{ required: true, message: '请选择执行时间' }]}
            style={{ marginBottom: '10px' }}
          >
            <TimePicker
              placeholder="请选择执行时间"
              format="HH:mm:ss"
              allowClear
              use12Hours={false}
              style={{ width: '100%' }}
              inputReadOnly={true}
              getPopupContainer={triggerNode => triggerNode.parentNode}
              popupStyle={{ zIndex: 1050 }}
              onChange={(time) => {
                // 选择时间后立即应用值
                form.setFieldsValue({ executeTime: time });
              }}
            />
          </Form.Item>
        </Col>
      </Row>
    );
  }
};

export default TimeSelector; 